import type { Analytics } from "./analytics";
import type { ProviderListeners } from "./provider-listeners";
import type { AnalyticsEvent } from "./analytics-event";

export abstract class Provider {
  public abstract key: string;
  protected abstract analytics: Analytics | undefined;
  protected abstract listeners: ProviderListeners;

  public install(analytics: Analytics): void {
    this.analytics = analytics;
    this.subscribeAll(() => {
      this.onInstall();
    });
  }

  protected abstract onInstall(): void;

  protected subscribeAll(callback: () => void): void {
    if (!this.analytics) return;

    Object.keys(this.listeners).forEach((eventName) => {
      const name = eventName as AnalyticsEvent["name"];

      const callback = this.listeners[name] as Parameters<
        typeof this.analytics.subscribe
      >["2"];
      if (callback && this.analytics) {
        this.analytics.subscribe(this.key, name, callback);
        this.analytics.store.subscribeToEvent(this.key, name);
      }
    });

    callback();
  }
}
